// extracted by mini-css-extract-plugin
module.exports = {"header":"_1c07ef37 mt4 mb0 pb4 fw4 bb b--black-10"};